module.exports = __webpack_public_path__ + "static/media/product-5.deb4bda5.jpg";